module.exports = __webpack_public_path__ + "img/company_verified.70cd40df.svg";